"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = exports.badgeRootSizes = exports.badgeSizes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../../tokens/typography");
/**
 * Размеры в ремах.
 */
exports.badgeSizes = {
    l: {
        textMarginX: '0.25rem',
        textMarginLeftAfterContent: '0.25rem',
    },
    s: {
        textMarginX: '0.125rem',
        textMarginLeftAfterContent: '0.125rem',
    },
};
exports.badgeRootSizes = {
    l: {
        height: '1.5rem',
        padding: '0.25rem',
        minWidth: '1.5rem',
        borderRadius: '0.75rem',
        fontSize: '0.75rem',
    },
    s: {
        height: '1rem',
        padding: '0.125rem',
        minWidth: '1rem',
        borderRadius: '0.5rem',
        fontSize: '0.625rem',
    },
};
var StyledText = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var StyledBadge = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n\n    width: max-content;\n\n    ", ";\n"], ["\n    ", ";\n\n    display: flex;\n    align-items: center;\n    box-sizing: border-box;\n    justify-content: center;\n\n    width: max-content;\n\n    ",
    ";\n"])), typography_1.caption, function (_a) {
    var size = _a.size, circled = _a.circled;
    return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        ", ";\n        ", "\n\n        ", " {\n            margin-left: ", ";\n            margin-right: ", ";\n        }\n\n        ", " ~ ", " {\n            margin-left: ", ";\n        }\n    "], ["\n        ", ";\n        ",
        "\n\n        ", " {\n            margin-left: ", ";\n            margin-right: ", ";\n        }\n\n        ", " ~ ", " {\n            margin-left: ", ";\n        }\n    "])), exports.badgeRootSizes[size], circled && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                width: ", ";\n                padding-left: 0;\n                padding-right: 0;\n            "], ["\n                width: ", ";\n                padding-left: 0;\n                padding-right: 0;\n            "])), exports.badgeRootSizes[size].minWidth), StyledText, exports.badgeSizes[size].textMarginX, exports.badgeSizes[size].textMarginX, StyledContent, StyledText, exports.badgeSizes[size].textMarginLeftAfterContent);
});
/**
 * Небольшая бирка для ячеек и карточек.
 * Компонент может отображаться в нескольких размерах и цветах, может содержать текст и/или иконку.
 */
exports.Badge = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'l' : _b, text = _a.text, contentLeft = _a.contentLeft, rest = __rest(_a, ["size", "text", "contentLeft"]);
    return (react_1.default.createElement(StyledBadge, __assign({ size: size }, rest),
        contentLeft && react_1.default.createElement(StyledContent, null, contentLeft),
        text && react_1.default.createElement(StyledText, null, text)));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Badge.js.map